// client/src/components/ContactForm.js

//ContactForm.js → createContact() → api.js → sanityWrite.js → Sanity CMS

import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import '../styles.css';
import { createContact } from '../api'; // API function for sending the contact form

function ContactForm() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const updateField = (setter) => (event) => {
        setter(event.target.value);
        setError('');
        setSubmitted(false);
    };

    // Client-side validation for form fields
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form fields
        if (!name || !email || !message) {
            setError('Please fill out all required fields.');
            return;
        }

        if (!/^[A-Za-z\s]{1,40}$/.test(name)) {
            setError('Name must be up to 40 characters long.');
            return;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 30) {
            setError('Please enter a valid email address up to 30 characters long.');
            return;
        }

        if (phone && !/^\d{10,15}$/.test(phone)) {
            setError('Please enter a valid phone number up to 15 digits.');
            return;
        }

        if (message.length > 1000) {
            setError('Message should not exceed 1000 characters.');
            return;
        }

        setError('');
        setSubmitted(false);
        setIsSubmitting(true);
        try {
            await createContact({ name, email, phone, message });
            setSubmitted(true);
            setName('');
            setEmail('');
            setPhone('');
            setMessage('');
        } catch (error) {
            setError(error.message || 'We could not send your message. Please try again later.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Form onSubmit={handleSubmit}>
            {error && <Alert variant="danger" role="alert">{error}</Alert>}
            {submitted && (
                <Alert variant="success" role="status" aria-live="polite">
                    Thank you for your message. It has been received, and a member of our team will contact you soon.
                </Alert>
            )}

            <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Name <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                    type="text"
                    placeholder="Enter your name"
                    value={name}
                    onChange={updateField(setName)}
                    maxLength={40}
                    required
                />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label>Email address <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={updateField(setEmail)}
                    maxLength={30}
                    required
                />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPhone">
                <Form.Label>Phone (optional)</Form.Label>
                <Form.Control
                    type="tel"
                    placeholder="Enter your phone number"
                    value={phone}
                    onChange={updateField(setPhone)}
                    maxLength={15}
                />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicMessage">
                <Form.Label>Message <span style={{ color: 'red' }}>*</span></Form.Label>
                <Form.Control
                    as="textarea"
                    rows={6}
                    placeholder="Enter your message (max 1000 characters)"
                    value={message}
                    onChange={updateField(setMessage)}
                    maxLength={1000}
                    required
                />
            </Form.Group>

            <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Submit'}
            </Button>
        </Form>
    );
}

export default ContactForm;
